import { ChevronRightIcon } from '@heroicons/react/20/solid';

// 「找不到你想要的產品？」提名卡片，點擊導向 /nominate
// title / subtitle 可覆寫預設文案（例如品牌頁改成「品牌」）
const NominateProduct = ({
  className = '',
  title = '找不到你想要的產品？',
  subtitle = '點我提名產品，即時評價賺分！',
}) => {
  return (
    <div
      className={`flex cursor-pointer items-center gap-x-2 rounded-lg border border-gray-300 p-4 ${className}`}
      onClick={() => {
        window.location = '/nominate';
      }}
    >
      <div className="flex min-w-0 flex-grow flex-col gap-y-2">
        <p className="text-base font-medium text-[#111928]">{title}</p>
        <p className="text-xs font-medium text-gray-800">{subtitle}</p>
      </div>
      <div>
        <ChevronRightIcon className="h-5 w-5 text-sorra-pink" />
      </div>
    </div>
  );
};

export default NominateProduct;
